import { ThemeProvider } from '@emotion/react';
import { Avatar, Chip, LinearProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { NormalButton } from 'components/atoms/Button';
import * as React from 'react';
import useStyles from "./MobileAvmBody.styles";

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const ParaText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#ffffff',
}));

const SmallText = styled(Typography)(({ theme }) => ({
  fontSize: '.8rem',
  color: '#ffffff',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '2.4rem',
  fontWeight: 'bold',
  color: '#ffffff',
}));

const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 5,
  backgroundColor: '#4d4b5a',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#ddb930',
  },
}));

const RewardCard = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(100deg, #325e6a, #313646)',
  padding: '1.5rem',
  borderRadius: '30px',
  marginBottom: '1rem',
  boxShadow: colortheme.shadows[4],
  position: 'relative',
  overflow: 'hidden',
  // #325e6a
  // #313646
  //shadow rgba(0,0,0,0.10196078431372549 )
}));
const RewardCardLayer = styled(Box)(({ theme }) => ({
  backgroundColor: "#C2CEED",
  borderRadius: "100% 75% 30px 30px",
  boxShadow: colortheme.shadows[4],
  position: "absolute",
  top: "50%",
  left: '50%',
  width: "120%",
  height: "50%",
  opacity: "0.05",
  zIndex: "0",
  transform: "translate(-50%)",
  /* overflow: hidden; */
}));

const RewardCardSmallLayer = styled(RewardCardLayer)(({ theme }) => ({
  borderRadius: "250% 50% 30px 30px",
  left: '50%',
  width: "150%",
  height: "250%",
}));

const SmallRewardCard = styled(RewardCard)(({ theme }) => ({
  background: 'linear-gradient(100deg, #325e6a, #313646)',
  padding: '1.5rem',
  borderRadius: '30px',
  marginBottom: '1rem',
  boxShadow: colortheme.shadows[4],

  // #325e6a
  // #313646
  //shadow rgba(0,0,0,0.10196078431372549 )
}));

const LightChip = styled(Chip)(({ theme }) => ({
  backgroundColor: 'rgba(0,0,0,.1)',
  color: '#fff',
  fontSize: '.8rem',
  padding: '1.2rem .6rem',
  borderRadius: '25px',
  height: '2rem',
  '& .MuiAvatar-root img': {
    width: '25px',
    height: '25px',
  },
}));

const ProfileImg = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '250px',
  height: '250px',
  zIndex: "1",
  [colortheme.breakpoints.down('md')]: {
    width: '150px',
    height: '150px',
  },
}));

const AvmBody = () => {
  const classes = useStyles();
  const useravatar = require('assets/Profile/buku_default_avatar.png');
  const moneyIcon = require('assets/icons/money.svg');

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box className={classes.main}>
          <Box>
            <TitleText style={{ margin: "1rem 0", fontSize: "1.6rem" }}>
                Welcome to Buku AVM!
            </TitleText>
            <ParaText style={{ color: "#c1c1c1" }}>
                AVM (Ad Viewership Money) is money you earn from
                watching ads on our platform. By continuing to use
                our platform and enjoying creators content you will
                also directly support your favorite creators.
            </ParaText>

            <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                <Grid item xs={12}>
                    <NormalButton text={"Create Wallet"} color={"yellow"} style={{ width: "100%" }} />
                </Grid>
                <Grid item xs={12}>
                    <NormalButton text={"Earned-334 AVM"} style={{ width: "100%" }} />
                </Grid>
                <Grid item xs={12}>
                    <NormalButton text={"Withdraw AVM"} style={{ width: "100%" }} />
                </Grid>
                <Grid item xs={12}>
                    <NormalButton text={"Disable Payouts"} style={{ width: "100%" }} />
                </Grid>
            </Grid>

            <Grid container style={{ margin: "2rem 0rem" }}>
                <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                    <ParaText>
                        Next Pay out
                    </ParaText>
                </Grid>

                <Grid item xs={12}>
                    <CustomLinearProgress
                        variant="determinate"
                        value={40}
                    />
                    <SmallText style={{ color: "#c1c1c1" }}>
                        6 DAYS LEFT
                    </SmallText>
                </Grid>
            </Grid>

            <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                <Grid item xs={12}>
                    <NormalButton style={{ width: "100%" }}>
                        Share my rewards
                    </NormalButton>
                </Grid>
            </Grid>
          </Box>
          
          <RewardCard>
            <RewardCardLayer></RewardCardLayer>
            <Grid
              container
              sx={{
                alignItems: 'center',
                marginBottom: '1rem',
                zIndex: '2',
                position: 'relative',
              }}
            >
              <Grid item xs={12}>
                <TitleText style={{ fontSize: '1.2rem' }}>
                  1. Your top creator of the month
                </TitleText>
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'start' }}>
                <ParaText
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                    color: '#ddb930',
                  }}
                >
                  <img
                    src={moneyIcon.default}
                    alt="money Icon"
                    width={20}
                    height={20}
                    style={{ marginRight: '.4rem' }}
                  />
                  PAYS OUT 300 AVM
                </ParaText>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <LightChip
                  avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                  label="@leahx1621"
                  style={{ marginLeft: '10px', marginBottom: "1rem", }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ProfileImg src={useravatar} alt="header back" />
                <ParaText
                  style={{
                    padding: '1rem 2rem',
                    textAlign: 'center',
                  }}
                >
                  Right now you support @leahx1621 the most and they will
                  receive 100 AVM at the end of the month.
                </ParaText>
              </Grid>
            </Grid>
          </RewardCard>


          {[1,2,3,4,5,6,7,8].map(i=>{
            return (
              <SmallRewardCard key={i}>
                <RewardCardSmallLayer></RewardCardSmallLayer>
                <Grid
                  container
                  sx={{
                    alignItems: 'center',
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <TitleText style={{ fontSize: '1.4rem' }}>
                      <LightChip
                        avatar={<Avatar alt="@leahx1621" src={useravatar} />}
                        label="@leahx1621"
                      />
                    </TitleText>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: 'start' }}>
                    <ParaText
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                        color: '#ddb930',
                        fontSize: ".8rem",
                      }}
                    >
                      <img
                        src={moneyIcon.default}
                        alt="money Icon"
                        width={20}
                        height={20}
                        style={{marginRight: "5px"}}
                      />
                      PAYS OUT 300 AVM
                    </ParaText>
                  </Grid>
                </Grid>
              </SmallRewardCard>
            )
          })}

        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default AvmBody;
